'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Text, { TextProps } from '../text'
import Button, { ButtonProps } from '../button'

/* -----------------------------------------------------------------------------
 * Tab
 * -------------------------------------------------------------------------- */

export type TabProps = ButtonProps & {
  active: boolean
  children?: React.ReactNode
  onPress?: (event: React.SyntheticEvent) => void
}

function Tab({ active, children, ...props }: TabProps) {
  const buttonProps = {
    borderRadius: '0',
    borderColor: 'red',
    ...props
  } as ButtonProps

  const textProps = {
    variant: 'label'
  } as TextProps

  if (active) {
    buttonProps['borderBottomWidth'] = 2
    textProps['textColor'] = 'violet'
  }

  return (
    <Button py='12' variant='punchThroughGray' fontSize={12} {...buttonProps}>
      <Text {...textProps}>{children}</Text>
    </Button>
  )
}

export default Tab
